import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';

import { DesignSystemPage } from '../../features/design/DesignSystemPage';

export const Route = createFileRoute('/$lang/design')({ component: Design });

/*
 * Thin on purpose, like every route: the feature slice holds the page so the router's
 * `autoCodeSplitting` emits it as its own chunk. The design-system reference is a developer
 * surface — a live specimen of 07 — but it rides the same public shell as any other page.
 */
function Design(): ReactNode {
  const { lang } = Route.useParams();
  return <DesignSystemPage lang={lang} />;
}
